<template>
  <div v-if="showContent" data-testid="hot-destinations-view">
    <HotDestinationsGrid :cities="citiesToShow" />
  </div>
</template>

<script>
import HotDestinationsGrid from './HotDestinationsGrid.vue'
import { createNamespacedHelpers } from 'vuex'
import availableCitiesMixin from '../mixins/availableCities'

const { mapGetters } = createNamespacedHelpers('offersDestinations')

export default {
  name: 'HotDestinations',
  components: {
    HotDestinationsGrid
  },
  mixins: [availableCitiesMixin],
  data() {
    return {
      dataReady: false
    }
  },
  computed: {
    ...mapGetters(['hotDestinations']),
    isFfQubitFixesEnabled() {
      return global.ConfigDynamic?.isEnabled({ key: 'default.qubit.fixes.active' })
    },
    citiesToShow() {
      return this.isFfQubitFixesEnabled ? this.availableCities : this.hotDestinations
    },
    showContent() {
      return this.isFfQubitFixesEnabled
        ? this.dataReady
        : this.hotDestinations && this.hotDestinations.length > 0
    }
  },
  watch: {
    hotDestinations: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.dataReady = true
        }
      },
      immediate: true
    }
  }
}
</script>
